import React, { useContext } from "react";
import TemplateElementWarningsService from "packs/services/convertflow/template_element_warnings_service";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import ConditionsBuilder from "../conditions/ConditionsBuilder";
import EmbedCampaignSettings from "../elements/EmbedCampaignSettings";
import SidePanelLabeledSection from "../shared/SidePanelLabeledSection";

const EmbedRecommendationSettings = (props) => {
  const [contextData] = useContext(VariantContextData);

  let website = contextData.objects.website;
  let cta = contextData.objects.cta;
  let variant = contextData.objects.variant;
  let embed_recommendation = props.embed_recommendation;
  let element = props.element;
  let existing_conditions = Object.values(variant.conditions).filter(
    (condition) =>
      condition.contactable_type == "EmbedRecommendation" &&
      condition.contactable_id == embed_recommendation.id &&
      condition.toBeDeleted !== true
  );
  let warningVisible = existing_conditions.length == 0;

  const embedCtaId = embed_recommendation.options["embed-cta-id"] || "";
  const embeddedCampaign =
    embedCtaId && website?.ctas
      ? website.ctas[embedCtaId] || website.ctas[String(embedCtaId)]
      : null;
  let object_info = embeddedCampaign
    ? embeddedCampaign.name || `Campaign ${embedCtaId}`
    : embedCtaId
    ? `Campaign ${embedCtaId}`
    : "Conditional Embed";

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={embed_recommendation}
        setting_name="[modal_trigger]"
        setting_type="item_v2"
        object_type="embed_recommendations"
        object_id={embed_recommendation.id}
        title={
          embed_recommendation.options["label"]
            ? embed_recommendation.options["label"]
            : object_info
        }
        modalTitle={`Embed Recommendation - ${
          embed_recommendation.options["label"]
            ? embed_recommendation.options["label"]
            : object_info
        }`}
        style={{ margin: "4px 0px" }}
        label_max_length={25}
        label_hover_max_length={14}
        panel_type="modal"
        side_panel={true}
        draggable="false"
        warning={
          warningVisible
            ? "Embed filter is incomplete"
            : TemplateElementWarningsService.getEmbedRecommendationRollupWarning(
                embed_recommendation,
                variant
              )
        }
        warningBorder={false}
        label_icon="fas fa-code"
        duplicate_payload={{
          element_id: element.id,
        }}
      >
        <VariantBuilderSetting
          object={embed_recommendation}
          setting_name="[options][label]"
          setting_type="text"
          object_type="embed_recommendations"
          object_id={embed_recommendation.id}
          label={`Label this embed recommendation`}
          value={
            embed_recommendation.options["label"]
              ? embed_recommendation.options["label"]
              : ""
          }
          placeholder="Write label here"
          update_on_input_end={true}
        />

        <SidePanelLabeledSection label="If">
          <ConditionsBuilder
            cta={cta}
            variant={variant}
            website={website}
            contactable_type="EmbedRecommendation"
            contactable_id={embed_recommendation.id}
            dark_mode={contextData.dark_mode}
            builder={true}
            hide_delete_button={true}
          />
        </SidePanelLabeledSection>

        <SidePanelLabeledSection label="Then">
          <EmbedCampaignSettings
            object={embed_recommendation}
            object_type="embed_recommendations"
            object_id={embed_recommendation.id}
          />
        </SidePanelLabeledSection>
      </VariantBuilderSetting>
    </React.Fragment>
  );
};

export default EmbedRecommendationSettings;
